import { render, staticRenderFns } from "./PainelResiduosSolidos.vue?vue&type=template&id=bd9ee358"
import script from "./PainelResiduosSolidos.vue?vue&type=script&lang=js"
export * from "./PainelResiduosSolidos.vue?vue&type=script&lang=js"
import style0 from "./PainelResiduosSolidos.vue?vue&type=style&index=0&id=bd9ee358&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports